import {
  Directive,
  ElementRef,
  Input,
  OnInit,
  SimpleChanges,
} from '@angular/core';

import { UrlType } from '../api/models';

@Directive({
  selector: '[urlTypeIcon]',
  standalone: true,
})
export class UrlTypeIconDirective implements OnInit {
  @Input() urlTypeIcon: UrlType;

  constructor(private element: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    this.element.nativeElement.className = this.getCssClassList();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['urlTypeIcon']) this.ngOnInit();
  }

  getCssClassList(): string {
    let classList = 'mdi mdi-26px ';
    switch (this.urlTypeIcon) {
      case UrlType.Facebook:
        classList += 'mdi-facebook text-primary ';
        break;
      case UrlType.Instagram:
        classList += 'mdi-instagram text-rose ';
        break;
      case UrlType.LinkedIn:
        classList += 'mdi-linkedin text-blue ';
        break;
      case UrlType.Telegram:
        classList += 'mdi-send-circle text-blue mdi-rotate-315 ';
        break;
      case UrlType.Twitter:
        classList += 'mdi-twitter text-sky ';
        break;
      case UrlType.WebSite:
        classList += 'mdi-web tw-text-gray-600 ';
        break;
      case UrlType.WhatsApp:
        classList += 'mdi-whatsapp text-success ';
        break;
      case UrlType.YouTube:
        classList += 'mdi-youtube text-danger ';
        break;
      case UrlType.GoogleLink:
      case UrlType.MapIrLink:
      case UrlType.NeshanLink:
      case UrlType.WazeLink:
        classList += 'mdi-map-marker-radius text-info ';
        break;

      default:
        classList += 'mdi-web-box text-primary ';
        break;
    }

    return classList;
  }
}
